module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THOMAS DUNNE BOOKS")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("An imprint of St. Martin’s Press.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SEAL WARRIOR")]), _vm._v(". Copyright © 2009 by Thomas H. Keith and J. Terry Riebling.")]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Foreword copyright © by Lt. Michael E. Thornton U.S. Navy (Ret.).")]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("All rights reserved. Printed in the United States of America. For information, address")]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "href": "http://www.thomasdunnebooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.thomasdunnebooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("All photos are courtesy of the Tom Keith collection.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Keith, Thomas H.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("    SEAL warrior : death in the dark—Vietnam, 1968–1972 / Thomas H. Keith and J. Terry Riebling ; foreword by Michael E. Thornton.—1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("         p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("    Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("    ISBN 978-0-312-37904-9")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("    1. Keith, Thomas H. 2. Vietnam War, 1961–1975—Personal narratives, American. 3. Vietnam War, 1961–1975—Commando operations. 4. United States. Navy. SEALs—Biography. 5. United States. Navy. SEALs—History—20th century. 6. Guerrillas—United States—Biography. 7. Guerrillas—"), _c('br'), _vm._v("Vietnam—Biography. 8. Guerrilla warfare—Vietnam—History—20th century. I. Riebling, J. Terry. II. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("DS559.5.K395 2009")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("959.704'38—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("[B]")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("2009007825")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("First Edition: July 2009")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("10   9   8   7   6   5   4   3   2   1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49af5c96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0